import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ArrowCircleRight } from "@mui/icons-material";
import { Typography, IconButton, InputAdornment, Box } from "@mui/material";
import { sendResetPasswordInstructions } from "../../utils/loginApi";
import LoginTextField from "./LoginTextField";

export default function ForgotPassword() {
  const { t, i18n } = useTranslation("common", { keyPrefix: "password" });
  const [emailSent, setEmailSent] = useState(false);
  const [searchParams] = useSearchParams();
  const { register, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    await sendResetPasswordInstructions({
      email: data.email,
      locale: i18n.language,
    });
    setEmailSent(true);
  };

  if (emailSent || searchParams.get("isSent")) {
    return (
      <Box sx={{ width: "100%", maxWidth: 700, mt: { xs: 4, md: 6 } }}>
        <Typography align="center" sx={{ fontSize: 18 }}>
          {t("forgotPasswordSuccessText")}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", maxWidth: 348 }}>
      <Typography align="center" sx={{ mb: 2 }}>
        {t("enterEmailInstructions")}
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)}>
        <LoginTextField
          required
          autoFocus
          type="email"
          id="email"
          label={t("enterEmail")}
          size="small"
          variant="filled"
          margin="dense"
          fullWidth
          {...register("email", { required: true })}
          slotProps={{
            htmlInput: {
              inputMode: "email",
              autoCapitalize: "none",
              autoCorrect: "off",
              spellCheck: false,
            },
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    type="submit"
                    aria-label={t("resetPassword")}
                    sx={{ p: 0, "&:hover": { background: "transparent" } }}
                  >
                    <ArrowCircleRight
                      color="success"
                      sx={{ height: 50, width: 40 }}
                    />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
      </form>
    </Box>
  );
}
